import {Fancybox} from "@fancyapps/ui";
import {Tooltip} from 'bootstrap';
import JsTabs from "js-tabs";
import Swiper, {Navigation, Thumbs, Pagination, Autoplay} from 'swiper';
Swiper.use([Navigation, Thumbs, Pagination, Autoplay]);
import StarRating from 'star-rating.js';
import events from "./base";

require('./base');

document.querySelectorAll('.star-rating').forEach(item => {
    new StarRating(item, {
        clearable: true,
        tooltip: false,
        maxStars: 5,
    });
});

if (document.querySelector('.spoiler')) {
    document.querySelectorAll('.spoiler-btn').forEach(function (item, index) {
        item.addEventListener('click', function (event) {
            event.preventDefault();
            item.classList.toggle('active');
            item.closest('.spoiler').classList.toggle('active');
            let container = document.querySelectorAll('.spoiler-block')[index];

            if (!container.classList.contains('active')) {
                container.classList.add('active');
                container.style.height = 'auto';
                let height = container.clientHeight + 'px';
                container.style.height = '0px';
                setTimeout(function () {
                    container.style.height = height;
                }, 0);
            } else {
                container.style.height = '0px';
                container.addEventListener('transitionend', function () {
                    container.classList.remove('active');
                }, {
                    once: true
                });
            }
        });
    });
}

if (document.querySelector('.product-tabs')) {
    const myTabs = new JsTabs({
        elm: '.product-tabs',
        shouldScrollTabIntoView: false,
    });
    myTabs.init();
    document.querySelector(".js-tabs__tab").classList.add("active");
    document.querySelector(".js-tabs__content").classList.add("active");
}

if (document.querySelector('.map-tabs')) {
    let cities = document.querySelectorAll('.map-contact');
    let address = document.querySelectorAll('.map-tabs');
    cities.forEach((city, i) => {
        city.addEventListener('click', () => {
            address.forEach(item => {
                item.querySelectorAll('.js-tabs__tab').forEach(e => {
                    e.classList.remove('active');
                });
                item.querySelectorAll('.js-tabs__content').forEach(e => {
                    e.classList.remove('active');
                });
            });
            address[i].querySelector('.js-tabs__tab').classList.add('active');
            address[i].querySelector('.js-tabs__content').classList.add('active');
        });
    });

    address.forEach(item => {
        const mapTabs = new JsTabs({
            elm: item,
            shouldScrollTabIntoView: false,
        });
        mapTabs.init();
        item.querySelector('.js-tabs__tab').classList.add('active');
        item.querySelector('.js-tabs__content').classList.add('active');
    });
}

if (document.querySelector('.spoiler-half')) {

    document.querySelectorAll('.spoiler-half-btn').forEach(function (item, index) {
        let btnText = item.querySelector('span').innerText;
        let text = document.querySelectorAll('.spoiler-half-block')[index].querySelector('.js_text_block').innerText;
        let halfText = text.substring(0, 570) + "...";
        document.querySelectorAll('.spoiler-half-block')[index].querySelector('.js_text_block').innerText = halfText;
        let textHeight = document.querySelectorAll('.spoiler-half-block')[index].querySelector('.js_text_block').clientHeight + 'px';

        item.addEventListener('click', function (event) {
            event.preventDefault();
            item.classList.toggle('active');
            item.closest('.spoiler-half').classList.toggle('active');
            let container = document.querySelectorAll('.spoiler-half-block')[index];
            item.querySelector('span').innerText = "Скрыть текст";
            if (!container.classList.contains('active')) {
                container.classList.add('active');
                container.querySelector('.js_text_block').innerText = text;
                container.style.height = 'auto';
                let height = container.clientHeight + 'px';
                container.style.height = textHeight;
                setTimeout(function () {
                    container.style.height = height;
                }, 0);
            } else {
                container.style.height = textHeight;
                item.querySelector('span').innerText = btnText;
                container.addEventListener('transitionend', function () {
                    container.classList.remove('active');
                    container.querySelector('.js_text_block').innerText = halfText;
                }, {
                    once: true
                });
            }
        });
    });
}

import ymaps from './Ymaps';
import Agent from "./Components/Core/agent";
import {notice} from "./Components/UI/notice";
import {initAddCommentForm} from "./Components/Comments/comment";

import {GET2URL} from "./Components/Url";
import {parseHTML} from "./Components/Core/common";

function init() {
    ymaps.load()
        .then(YMaps => {
            let points = [];

            document.querySelectorAll('.js_office_coordinates').forEach(item => {
                points[item.dataset.category] = new YMaps.GeoPoint(item.dataset.longitude, item.dataset.latitude);
            });

            let map = new YMaps.Map(YMaps.jQuery("#YaMaps")[0]);
            // Устанавливает начальные параметры отображения карты: центр карты и коэффициент масштабирования

            // Стили для метки
            let s = new YMaps.Style();
            s.iconStyle = new YMaps.IconStyle();
            s.iconStyle.href = "/images/map-icon.svg";
            s.iconStyle.size = new YMaps.Point(50, 50);
            s.iconStyle.offset = new YMaps.Point(-30, -40);

            // Создание меток
            points.forEach(point => {
                map.addOverlay(new YMaps.Placemark(point, {style: s}));
            });

            // Перемещение по карте
            if (document.querySelector('.map-contact')) {
                map.setCenter(points[document.querySelector('.map-contact').dataset.category], 18);
                document.querySelectorAll('.map-contact').forEach(item => {
                    item.addEventListener('click', () => {
                        map.panTo(points[item.dataset.category], {flying: 1});
                    });
                });
            }

            if (document.querySelector('.map-address')) {
                document.querySelector('.map-address').classList.add('active');
                map.setCenter(points[document.querySelector('.map-address').dataset.category], 18);
                document.querySelectorAll('.map-address').forEach(item => {
                    item.addEventListener('click', () => {
                        document.querySelectorAll('.map-address').forEach(i => {
                            i.classList.remove('active');
                        });
                        item.classList.add('active');
                        map.panTo(points[item.dataset.category], {flying: 1});
                    });
                });
            } else {
                map.setCenter(points[0], 18);
            }

        }).catch(error => console.log('Failed to load Yandex Maps', error));
}

if (document.querySelector(".maploader")) {
    document.querySelector('.maploader').addEventListener('click', init);
}else if(document.querySelector(".map-autoloader")){
    init();
} else if (document.querySelector('#YaMaps')) {
    init();
}

document.querySelectorAll('.chosen-item').forEach(item => {
    item.querySelector('.btn-close').addEventListener('click', () => {
        if (item.closest('[class^="col-"]')) {
            item.closest('[class^="col-"]').remove();
        } else {
            item.remove();
        }
    });
});

if (document.querySelector('.category-filter')) {
    let btn = document.querySelector('.btn-filter');
    let filter = document.querySelector('.category-filter');
    document.addEventListener('click', (e) => {
        if (filter.classList.contains('active')) {
            if (e.target === filter) {
                filter.classList.remove('active');
            }
        }
    });

    btn.addEventListener('click', () => {
        filter.classList.add('active');
    });
}

document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.slider-4')) {
        document.querySelectorAll('.slider-4').forEach(item => {
            let currentCategory = item.dataset.category;
            let currentNavigation = document.querySelector(`.slider-pagination-4[data-category="${currentCategory}"]`);
            let navigation = {};
            if (currentNavigation) {
                let next = currentNavigation.querySelector('.slider-next');
                let prev = currentNavigation.querySelector('.slider-prev');
                navigation = {
                    nextEl: next,
                    prevEl: prev,
                };
            }
            new Swiper(item, {
                spaceBetween: 10,
                slidesPerView: 2,
                navigation: navigation,
                watchSlidesVisibility: true,
                slideActiveClass: "active",
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 30
                    },
                    1524: {
                        spaceBetween: 40,
                        slidesPerView: 4,
                    },
                }
            });
        });
    }
    if (document.querySelector('.slider-2')) {
        document.querySelectorAll('.slider-2').forEach(item => {
            let currentCategory = item.dataset.category;
            let currentNavigation = document.querySelector(`.slider-pagination-2[data-category="${currentCategory}"]`);
            let navigation = {};
            if (currentNavigation) {
                let next = currentNavigation.querySelector('.slider-next');
                let prev = currentNavigation.querySelector('.slider-prev');
                navigation = {
                    nextEl: next,
                    prevEl: prev,
                };
            }
            new Swiper(item, {
                spaceBetween: 10,
                slidesPerView: 1,
                navigation: navigation,
                watchSlidesVisibility: true,
                slideActiveClass: "active",
                breakpoints: {
                    576: {
                        slidesPerView: 1,
                        spaceBetween: 20
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    1524: {
                        slidesPerView: 2,
                        spaceBetween: 40
                    }
                }
            });
        });
    }
    if(document.querySelector('.slider-3')){
        document.querySelectorAll('.slider-3').forEach(item => {
            let currentCategory = item.dataset.category;
            let currentNavigation = document.querySelector(`.slider-pagination-3[data-category="${currentCategory}"]`);
            let navigation = {};
            if (currentNavigation) {
                let next = currentNavigation.querySelector('.slider-next');
                let prev = currentNavigation.querySelector('.slider-prev');
                navigation = {
                    nextEl: next,
                    prevEl: prev,
                };
            }
            new Swiper(item, {
                spaceBetween: 10,
                slidesPerView: 'auto',
                navigation: navigation,
                watchSlidesVisibility: true,
                slideActiveClass: "active",
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    992: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    },
                    1524: {
                        spaceBetween: 40,
                        slidesPerView: 3,
                    },
                }
            });
        });
    }
    if (document.querySelector('.slider-5')) {
        document.querySelectorAll('.slider-5').forEach(item => {
            let currentCategory = item.dataset.category;
            let currentNavigation = document.querySelector(`.slider-pagination-5[data-category="${currentCategory}"]`);
            let navigation = {};
            if (currentNavigation) {
                let next = currentNavigation.querySelector('.slider-next');
                let prev = currentNavigation.querySelector('.slider-prev');
                navigation = {
                    nextEl: next,
                    prevEl: prev,
                };
            }
            new Swiper(item, {
                spaceBetween: 10,
                slidesPerView: 2,
                navigation: navigation,
                watchSlidesVisibility: true,
                slideActiveClass: "active",
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 30
                    },
                    1524: {
                        spaceBetween: 30,
                        slidesPerView: 5,
                    },
                }
            });
        });
    }

    if (document.querySelector(".product-slide")) {
        let swiperProductThumbs = new Swiper('.product-slide-thumbs', {
            spaceBetween: 10,
            slidesPerView: 2,
            watchSlidesVisibility: true,
            slideActiveClass: "active",
            breakpoints: {
                768: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4
                }
            }
        });
        new Swiper('.product-slide', {
            spaceBetween: 10,
            slidesPerView: 1,
            thumbs: {
                swiper: swiperProductThumbs
            },
            navigation: {
                nextEl: ".product-slide-next",
                prevEl: ".product-slide-prev",
            }
        });
    }
    document.querySelectorAll('.baner-slide').forEach(slider => {
        new Swiper(slider, {
            spaceBetween: 10,
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: ".baner-slide-next",
                prevEl: ".baner-slide-prev",
            }, 
            pagination: {
                el: '.baner-slide-pagination',
                type: 'bullets',
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
        })
    })
    document.querySelectorAll('.sliderSM-3').forEach(item => {
        let currentCategory = item.dataset.category;
        let currentNavigation = document.querySelector(`.sliderSM-pagination-3[data-category="${currentCategory}"]`);
        let navigation = {};
        if (currentNavigation) {
            let next = currentNavigation.querySelector('.slider-next');
            let prev = currentNavigation.querySelector('.slider-prev');
            navigation = {
                nextEl: next,
                prevEl: prev,
            };
        }
        new Swiper(item, {
            spaceBetween: 10,
            slidesPerView: 'auto',
            navigation: navigation,
            watchSlidesVisibility: true,
            slideActiveClass: "active",
            breakpoints: {
                576: {
                    spaceBetween: 10,
                    slidesPerView: 2,
                },
                992: {
                    spaceBetween: 10,
                    slidesPerView: 2,
                },
                1200: {
                    spaceBetween: 10,
                    slidesPerView: 3
                },
                1524: {
                    spaceBetween: 10,
                    slidesPerView: 3,
                },
            }
        });
    });
});

const loadCommentForm = document.querySelector('.js_load_comment_form');
if (loadCommentForm) {
    let observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                let js_comment_form = document.querySelector('.js_comment_form');

                if (!js_comment_form) {
                    obs.unobserve(entry.target);
                }

                if (!js_comment_form.querySelector('form')) {
                    let id = loadCommentForm.getAttribute('data-page');
                    let type = loadCommentForm.getAttribute('data-type');
                    Agent.post(`/api/comment/form/${id}/${type}/`).then(e => e.json()).then(e => {
                        if (e.success) {
                            js_comment_form.innerHTML = e.data;
                            initAddCommentForm(js_comment_form.querySelector('form'));
                        } else {
                            notice(e.message);
                        }
                    }).catch(e => console.log(e)).finally(() => {
                        obs.unobserve(entry.target);
                    });
                }

            }
        });
    });

    observer.observe(loadCommentForm);
}

const Share = {
    vkontakte: function (purl, ptitle) {
        let url = 'http://vkontakte.ru/share.php?';
        url += 'url=' + encodeURIComponent(purl);
        url += '&title=' + encodeURIComponent(ptitle);
        //url += '&description=' + encodeURIComponent(text);
        //url += '&image='       + encodeURIComponent(pimg);
        url += '&noparse=true';
        Share.popup(url);
    },
    odnoklassniki: function (purl, ptitle) {
        let url = 'https://connect.ok.ru/offer';
        url += '?url=' + encodeURIComponent(purl);
        url += '&title=' + encodeURIComponent(ptitle);
        //url += '&imageUrl=' + encodeURIComponent(pimg);
        Share.popup(url);
    },
    facebook: function (purl, ptitle) {
        let url = 'http://www.facebook.com/sharer.php?s=100';
        url += '&p[title]=' + encodeURIComponent(ptitle);
        //url += '&p[summary]='   + encodeURIComponent(text);
        url += '&p[url]=' + encodeURIComponent(purl);
        //url += '&p[images][0]=' + encodeURIComponent(pimg);
        Share.popup(url);
    },
    whatsapp: function (purl, ptitle) {
        let url = 'https://api.whatsapp.com/send?';
        url += 'url=' + encodeURIComponent(purl);
        url += '&title=' + encodeURIComponent(ptitle);
        Share.popup(url);
    },

    popup: function (url) {
        window.open(url, '', 'toolbar=0,status=0,width=626,height=436');
    }
};
window.Share = Share;

document.querySelectorAll('a[href*="#"]').forEach(item => item.addEventListener('click', e => {

    try{
        const block = document.querySelector(item.getAttribute('href'));
        e.preventDefault();
        if (block) {
            block.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
            block.click();
        }
    }catch (e){

    }
}));

let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl);
});

document.querySelectorAll('.js_load_more').forEach(item => item.addEventListener('click', () => {

    let url = item.dataset.api + GET2URL({}, []);
    item.classList.add('preloader');

    Agent.post(url, '')
        .then(e => e.json())
        .then(e => {
            if (e.success) {
                if (e.next) {
                    item.dataset.api = e.next;
                } else {
                    item.classList.add('d-none');
                }
                if (e.data.length) {
                    item.closest('.js_load_more_container').querySelector('.js_load_more_container_block').append(parseHTML(e.data));
                    events.dispatch('filter.search');
                }
            }
        })
        .catch(e => console.log(e))
        .finally(() => {
            item.classList.remove('preloader');
        });
}));

let tcr = document.querySelector('[name="tcr"]');
if(tcr){
    tcr.click();
    
}
